var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Box, TextField } from '@mui/material';
import { useRequest } from '../../../../hooks/requestHook';
import { cuppingComment as api } from '../../../../api';
import { useNotify } from '../../../../hooks/notificationHook';
import Button from '../../../atoms/BaseButton';
import QuantityField from '../../../atoms/QuantityField';
import CuppingDescriptorsAutocomplete from '../../../../components/organisms/CuppingComments/CuppingDescriptorsAutocomplete';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  button[type='reset'] {\n    margin-left: 16px;\n  }\n"], ["\n  button[type='reset'] {\n    margin-left: 16px;\n  }\n"])));
var QuantityFieldWrapper = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  .label {\n    flex: 1;\n    text-align: left;\n    font-size: 18px;\n    line-height: 2em;\n    font-weight: bold;\n  }\n  .field {\n    width: 120px;\n  }\n"], ["\n  display: flex;\n  .label {\n    flex: 1;\n    text-align: left;\n    font-size: 18px;\n    line-height: 2em;\n    font-weight: bold;\n  }\n  .field {\n    width: 120px;\n  }\n"])));
var CuppingCommentForm = function (_a) {
    var offerId = _a.offerId, comment = _a.comment, onSubmit = _a.onSubmit, onCancel = _a.onCancel;
    var t = useTranslation().t;
    var createApi = useRequest(api.create);
    var updateApi = useRequest(api.update);
    var notify = useNotify();
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(''), commentBody = _c[0], setCommentBody = _c[1];
    var _d = React.useState(), cuppingScoreTotal = _d[0], setCuppingScoreTotal = _d[1];
    var _e = React.useState([]), descriptors = _e[0], setDescriptors = _e[1];
    React.useEffect(function () {
        var _a;
        var score = Number((_a = comment === null || comment === void 0 ? void 0 : comment.cuppingScore) === null || _a === void 0 ? void 0 : _a.total);
        if (!isNaN(score)) {
            setCuppingScoreTotal(score);
        }
        setDescriptors((comment === null || comment === void 0 ? void 0 : comment.cuppingDescriptors) || []);
        setCommentBody((comment === null || comment === void 0 ? void 0 : comment.body) || '');
    }, [comment]);
    var createComment = React.useCallback(function (body, descriptors, cuppingScore) { return __awaiter(void 0, void 0, void 0, function () {
        var cuppingComment, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cuppingComment = { offer_id: offerId, body: body, cupping_descriptors: descriptors };
                    if (cuppingScore !== undefined) {
                        cuppingComment.cupping_score = { total: cuppingScore };
                    }
                    return [4 /*yield*/, createApi({ cupping_comment: cuppingComment })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.commentSuccess')]);
                    onSubmit(response);
                    setCommentBody('');
                    setCuppingScoreTotal(undefined);
                    return [2 /*return*/];
            }
        });
    }); }, [createApi, t, notify, offerId, onSubmit]);
    var updateComment = React.useCallback(function (id, body, descriptors, cuppingScore) { return __awaiter(void 0, void 0, void 0, function () {
        var cuppingComment, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cuppingComment = { body: body, cupping_descriptors: descriptors };
                    if (cuppingScore !== undefined) {
                        cuppingComment.cupping_score = { total: cuppingScore };
                    }
                    return [4 /*yield*/, updateApi({
                            id: id,
                            cupping_comment: cuppingComment,
                        })];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.updateSuccess')]);
                    onSubmit(response);
                    setCommentBody('');
                    setCuppingScoreTotal(undefined);
                    return [2 /*return*/];
            }
        });
    }); }, [updateApi, t, notify, onSubmit]);
    var upsertComment = React.useCallback(function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    body = commentBody.trim();
                    setLoading(true);
                    if (!comment) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateComment(comment.id, body, descriptors, cuppingScoreTotal)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createComment(body, descriptors, cuppingScoreTotal)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [
        createComment,
        updateComment,
        comment,
        commentBody,
        descriptors,
        cuppingScoreTotal,
    ]);
    var reset = React.useCallback(function () {
        if (!onCancel || !comment)
            return;
        onCancel(comment);
    }, [onCancel, comment]);
    return (React.createElement(Form, { onSubmit: upsertComment, onReset: reset },
        React.createElement(Box, { py: 2, textAlign: "center" },
            React.createElement(Box, { marginY: 1, textAlign: "right" },
                React.createElement(QuantityFieldWrapper, { marginY: 1, textAlign: "right" },
                    React.createElement("div", { className: "label" }, t('params.cuppingScore.total')),
                    React.createElement("div", { className: "field" },
                        React.createElement(QuantityField, { min: 0, max: 100, step: 0.25, onChange: function (value) { return setCuppingScoreTotal(value); }, value: cuppingScoreTotal, disabled: loading }))),
                React.createElement(Box, { py: 1, textAlign: "center" },
                    React.createElement(CuppingDescriptorsAutocomplete, { value: descriptors, onChange: function (values) { return setDescriptors(values); } })),
                React.createElement(Box, { py: 1, textAlign: "center" },
                    React.createElement(TextField, { multiline: true, fullWidth: true, variant: "outlined", rows: 5, label: t('pages.roasterOrder.comment'), InputLabelProps: {
                            shrink: true,
                        }, value: commentBody, onChange: function (event) { return setCommentBody(event.target.value); }, disabled: loading }))),
            comment ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { type: "submit", disabled: loading }, t('pages.roasterOrder.updateComment')),
                React.createElement(Button, { type: "reset", disabled: loading }, t('buttons.cancel')))) : (React.createElement(Button, { type: "submit", disabled: loading }, t('pages.roasterOrder.postComment'))))));
};
export default CuppingCommentForm;
var templateObject_1, templateObject_2;
